import React from "react";

const PrivacyPage = () => {
  return (
    <main className="privacy-page"
      style={{
        padding: 32,
        maxWidth: 980,
        margin: "0 auto",
        fontFamily:
          "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
        lineHeight: 1.6,
        color: "#111",
        background: "#fff",
        textAlign: "justify",
        textJustify: "inter-word",
        textAlignLast: 'left'
      }}
    >
      <article>
        <style>{`
          .privacy-page ul li{margin-bottom:12px;}
          .privacy-page p,
          .privacy-page li,
          .privacy-page h1,
          .privacy-page h2,
          .privacy-page h3,
          .privacy-page h4,
          .privacy-page address
        `}</style>
        <header>
          <h1 style={{ fontSize: 28, marginBottom: 12 }}>
            Политика конфиденциальности и обработки персональных данных
          </h1>
        </header>

        <section style={{ marginBottom: 18 }}>
          <p>
            <strong style={{ fontSize: 18 }}>Опция 1.</strong> Для персонализации сервисов сайт pro-wellness.ru использует cookies, применяя метрические и иные системы аналитики в соответствии с Политикой конфиденциальности и Соглашением об обработке персональных данных. Запретить эти действия можно в настройках браузера. Ознакомиться с Согласием на обработку персональных данных
          </p>

          <p>
            <strong style={{ fontSize: 18 }}>Опция 2.</strong> Оставаясь на сайте, вы выражаете свое согласие на обработку персональных данных в соответствии с политикой в отношении обработки персональных данных ООО ПРО ВЕЛНЕС
          </p>

          <p>
            <strong>Дополнительная опция.</strong> Дополнительная опция для политики обработки cookie-файлов. Наш сайт собирает пользовательские данные. Продолжая использовать веб-ресурс – https://pro-wellness.ru/ вы соглашаетесь с Политикой cookies и даёте согласие на обработку файлов cookie
          </p>
        </section>

        <section>
          <h2>Политика в отношении обработки персональных данных</h2>
          <h3>Общие положения</h3>
          <div style={{ display: "flex", gap: 8 }}>
            <span>1.</span>
            <div><p>1.	Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006. № 152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и определяет порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые Обществом с ограниченной ответственностью ПРО ВЕЛНЕС (далее — Оператор).
            </p>

              <p>
                1.1. Оператор ставит своей важнейшей целью и условием осуществления
                своей деятельности соблюдение прав и свобод человека и гражданина при
                обработке его персональных данных, в том числе защиты прав на
                неприкосновенность частной жизни, личную и семейную тайну.
              </p>

              <p>
                1.2. Настоящая политика Оператора в отношении обработки персональных
                данных (далее — Политика) применяется ко всей информации, которую
                Оператор может получить о посетителях веб‑сайта https://pro-wellness.ru/.
              </p>
            </div>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>2.</span>
          <div>
            <h3>Основные понятия, используемые в Политике</h3>
            <ul>
              <li>
                2.1. Автоматизированная обработка персональных данных — обработка
                персональных данных с помощью средств вычислительной техники.
              </li>
              <li>
                2.2. Блокирование персональных данных — временное прекращение
                обработки персональных данных (за исключением случаев, если
                обработка необходима для уточнения персональных данных).
              </li>
              <li>
                2.3. Веб‑сайт — совокупность графических и информационных материалов,
                а также программ для ЭВМ и баз данных, обеспечивающих их доступность
                в сети интернет по сетевому адресу https://pro-wellness.ru/.
              </li>
              <li>
                2.4. Информационная система персональных данных — совокупность
                содержащихся в базах данных персональных данных и обеспечивающих их
                обработку информационных технологий и технических средств.
              </li>
              <li>
                2.5. Обезличивание персональных данных — действия, в результате
                которых невозможно определить без использования дополнительной
                информации принадлежность персональных данных конкретному
                Пользователю или иному субъекту персональных данных.
              </li>
              <li>
                2.6. Обработка персональных данных — любое действие (операция) или
                совокупность действий (операций), совершаемых с использованием
                средств автоматизации или без использования таких средств с
                персональными данными, включая сбор, запись, систематизацию,
                накопление, хранение, уточнение (обновление, изменение), извлечение,
                использование, передачу (распространение, предоставление, доступ),
                обезличивание, блокирование, удаление, уничтожение персональных
                данных.
              </li>
              <li>
                2.7. Оператор — государственный орган, муниципальный орган,
                юридическое или физическое лицо, самостоятельно или совместно с
                другими лицами организующие и/или осуществляющие обработку
                персональных данных, а также определяющие цели обработки
                персональных данных, состав персональных данных, подлежащих
                обработке, действия (операции), совершаемые с персональными данными.
              </li>
              <li>
                2.8. Персональные данные — любая информация, относящаяся прямо или
                косвенно к определенному или определяемому Пользователю веб‑сайта
                https://pro-wellness.ru/.
              </li>
              <li>
                2.9. Персональные данные, разрешенные субъектом персональных данных для распространения, — персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом персональных данных путем дачи согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения в порядке, предусмотренном Законом о персональных данных (далее — персональные данные, разрешенные для распространения).
              </li>
              <li>2.10. Пользователь — любой посетитель веб‑сайта.</li>
              <li>2.11. Предоставление персональных данных — действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц.</li>
              <li>2.12. Распространение персональных данных — любые действия, направленные на раскрытие персональных данных неопределенному кругу лиц (передача персональных данных) или на ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование персональных данных в средствах массовой информации, размещение в информационно-телекоммуникационных сетях или предоставление доступа к персональным данным каким-либо иным способом.</li>
              <li>2.13. Трансграничная передача персональных данных — передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому или иностранному юридическому лицу.</li>
              <li>2.14. Уничтожение персональных данных — любые действия, в результате которых персональные данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных в информационной системе персональных данных и/или уничтожаются материальные носители персональных данных.</li>
            </ul>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>3.</span>
          <div>
            <h3>Основные права и обязанности Оператора</h3>
            <p>3.1. Оператор имеет право:
              Оператор имеет право:
              — получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные;
              — в случае отзыва субъектом персональных данных согласия на обработку персональных данных, а также, направления обращения с требованием о прекращении обработки персональных данных, Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Законе о персональных данных;
              — самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Законом о персональных данных или другими федеральными законами.
            </p>

            <ul>
              3.2. Оператор обязан:<li> — предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его персональных данных;</li>
              <li> — организовывать обработку персональных данных в порядке, установленном действующим законодательством РФ;</li>
              <li> — отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Закона о персональных данных;</li>
              <li> — сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу этого органа необходимую информацию в течение 10 (десяти) календарных дней с даты получения такого запроса;</li>
              <li> — публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике в отношении обработки персональных данных;</li>
              <li> — принимать правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных данных, а также от иных неправомерных действий в отношении персональных данных;</li>
              <li> — прекратить передачу (распространение, предоставление, доступ) персональных данных, прекратить обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных данных;</li>
              <li> — исполнять иные обязанности, предусмотренные Законом о персональных данных.</li>

            </ul>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>4.</span>

          <div>
            <h3>Основные права и обязанности субъектов персональных данных</h3>
            <p>4.1. Права:</p>
            <ul>
              Субъекты персональных данных имеют право:
              <li>— получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящихся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Законом о персональных данных;</li>
              <li>— требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав;</li>
              <li>— выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг;</li>
              <li>— на отзыв согласия на обработку персональных данных, а также, на направление требования о прекращении обработки персональных данных;</li>
              <li>— обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных;</li>
              <li>— на осуществление иных прав, предусмотренных законодательством РФ.</li>

            </ul>

            <p>4.2. Субъекты персональных данных обязаны:</p>
            <ul>
              <li>- предоставлять Оператору достоверные данные о себе;</li>
              <li>- сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.</li>
            </ul>

            <p>4.3. Лица, передавшие Оператору недостоверные сведения о себе, либо сведения о  другом субъекте персональных данных без согласия последнего, несут ответственность в соответствии с законодательством РФ.</p>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>5.</span>
          <div>
            <h3>Принципы обработки персональных данных</h3>
            <ul>
              <li>5.1. Обработка персональных данных осуществляется на законной и справедливой основе;</li>
              <li>5.2. Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.</li>
              <li>5.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в целях, несовместимых между собой.</li>
              <li>5.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки.</li>
              <li>5.5. Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки. Не допускается избыточность обрабатываемых персональных данных по отношению к заявленным целям их обработки.</li>
              <li>5.6. При обработке персональных данных обеспечивается точность персональных данных, их достаточность, а в необходимых случаях и актуальность по отношению к целям обработки персональных данных. Оператор принимает необходимые меры и/или обеспечивает их принятие по удалению или уточнению неполных или неточных данных.</li>
              <li>5.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем по которому является субъект персональных данных. Обрабатываемые персональные данные уничтожаются либо обезличиваются по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено федеральным законом.</li>
            </ul>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>6.</span>
          <div>
            <h3>Цели обработки персональных данных</h3>
            <div style={{ display: "flex", gap: 100, justifyContent: "space-between", marginBottom: 10 }}>
              <p>Цель обработки</p>
              <ul style={{ maxWidth: 350 }}>
                <li>-	обеспечение корректного функционирования сайта проведения анализа его посещаемости;</li>
                <li>-	аналитика, маркетинг и реклама, продвижение в поисковых системах.</li>
              </ul>
            </div>
            <div style={{ display: "flex", gap: 100, justifyContent: "space-between", marginBottom: 10 }}>
              <p>Персональные данные</p>
              <ul style={{ maxWidth: 350 }}>
                <li>-	файлы cookie;</li>
                <li>-	сведения о действиях пользователя на сайте,</li>
                <li>-	сведения об оборудовании пользователя,</li>
                <li>-	дата и время сессии.</li>
              </ul>
            </div>
            <div style={{ display: "flex", gap: 100, justifyContent: "space-between", marginBottom: 10 }}>
              <p>Правовые основания</p>
              <ul style={{ maxWidth: 350 }}>
                <li>-	п. 5 ч. 1 ст. 6 Федерального закона № 152-ФЗ — обработка необходима для функционирования Сайта и предоставления Пользователю доступа к его функционалу;</li>
                <li>-	п. 1 ч. 1 ст. 6 Федерального закона № 152-ФЗ — обработка осуществляется на основании согласия Пользователя на использование файлов cookie для целей аналитики и маркетинга.</li>
              </ul>
            </div>

            <div style={{ display: "flex", gap: 100, justifyContent: "space-between", marginBottom: 10 }}>
              <p>Виды обработки персональных данных</p>
              <ul style={{ maxWidth: 350 }}>
                <li>сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, блокирование, удаление, уничтожение.</li>
              </ul>
            </div>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>7.</span>
          <div>
            <h3>Условия обработки персональных данных</h3>
            <ul>
              <li>7.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных.</li>
              <li>7.2. Обработка персональных данных необходима для достижения целей, предусмотренных международным договором Российской Федерации или законом, для осуществления возложенных законодательством Российской Федерации на оператора функций, полномочий и обязанностей.</li>
              <li>7.3. Обработка персональных данных необходима для осуществления правосудия, исполнения судебного акта, акта другого органа или должностного лица, подлежащих исполнению в соответствии с законодательством Российской Федерации об исполнительном производстве.</li>
              <li>7.4. Обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем, по которому является субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем.</li>
              <li>7.5. Обработка персональных данных необходима для осуществления прав и законных интересов оператора или третьих лиц либо для достижения общественно значимых целей при условии, что при этом не нарушаются права и свободы субъекта персональных данных.</li>
              <li>7.6. Осуществляется обработка персональных данных, доступ неограниченного круга лиц, к которым предоставлен субъектом персональных данных либо по его просьбе (далее — общедоступные персональные данные).</li>
              <li>7.7. Осуществляется обработка персональных данных, подлежащих опубликованию или обязательному раскрытию в соответствии с федеральным законом.</li>
            </ul>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>8.</span>
          <div>
            <h3>Порядок сбора, хранения, передачи и других видов обработки персональных данных</h3>
            <p>Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путем реализации правовых, организационных и технических мер, необходимых для выполнения в полном объеме требований действующего законодательства в области защиты персональных данных.</p>
            <ul>
              <li>8.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ к персональным данным неуполномоченных.</li>
              <li>8.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за исключением случаев, связанных с исполнением действующего законодательства либо в случае, если субъектом персональных данных дано согласие Оператору на передачу данных третьему лицу для исполнения обязательств по гражданско-правовому договору.</li>
              <li>8.3. В случае выявления неточностей в персональных данных, Пользователь может актуализировать их самостоятельно, путем направления Оператору уведомление на адрес электронной почты Оператора info@pro-wellness.ru с пометкой «Актуализация персональных данных».</li>
              <li>8.4. Срок обработки персональных данных определяется достижением целей, для которых были собраны персональные данные, если иной срок не предусмотрен договором или действующим законодательством. Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив Оператору уведомление посредством электронной почты на электронный адрес Оператора info@pro-wellness.ru. с пометкой «Отзыв согласия на обработку персональных данных».
              </li>
              <li>8.5. Вся информация, которая собирается сторонними сервисами, в том числе платежными системами, средствами связи и другими поставщиками услуг, хранится и обрабатывается указанными лицами (Операторами) в соответствии с их Пользовательским соглашением и Политикой конфиденциальности. Субъект персональных данных и/или с указанными документами. Оператор не несет ответственность за действия третьих лиц, в том числе указанных в настоящем пункте поставщиков услуг.</li>
              <li>8.6. Установленные субъектом персональных данных запреты на передачу (кроме предоставления доступа), а также на обработку или условия обработки (кроме получения доступа) персональных данных, разрешенных для распространения, не действуют в случаях обработки персональных данных в государственных, общественных и иных публичных интересах, определенных законодательством РФ.</li>
              <li>8.7. Оператор при обработке персональных данных обеспечивает конфиденциальность персональных данных.</li>
              <li>8.8. Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем, по которому является субъект персональных данных.</li>
              <li>8.9. Условием прекращения обработки персональных данных может являться достижение целей обработки персональных данных, истечение срока действия согласия субъекта персональных данных, отзыв согласия субъектом персональных данных или требование о прекращении обработки персональных данных, а также выявление неправомерной обработки персональных данных.</li>
            </ul>
          </div>
        </section>

        {/* Добавлены секции 9–12 в соответствии с присланным текстом */}
        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>9.</span>
          <div>
            <h3>Перечень действий, производимых Оператором с полученными персональными данными</h3>
            <ul>
              <li>9.1. Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление и уничтожение персональных данных.</li>
              <li>9.2. Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей полученной информации по информационно‑телекоммуникационным сетям или без таковой.</li>
            </ul>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>10.</span>
          <div>
            <h3>Трансграничная передача персональных данных</h3>
            <ul>
              <li>10.1. Оператор до начала осуществления деятельности по трансграничной передаче персональных данных обязан уведомить уполномоченный орган по защите прав субъектов персональных данных о своем намерении осуществлять трансграничную передачу персональных данных (такое уведомление направляется отдельно от уведомления о намерении осуществлять обработку персональных данных).</li>
              <li>10.2. Оператор до подачи вышеуказанного уведомления обязан получить от органов власти иностранного государства, иностранных физических лиц, иностранных юридических лиц, которым планируется трансграничная передача персональных данных, соответствующие сведения.</li>
            </ul>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>11.</span>
          <div>
            <h3>Конфиденциальность персональных данных</h3>
            <p>Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом.</p>
          </div>
        </section>

        <section style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <span>12.</span>
          <div>
            <h3>Заключительные положения</h3>
            <p>12.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его персональных данных, обратившись к Оператору с помощью электронной почты <a style={{ color: "inherit", textDecoration: "none" }} href="mailto:info@pro-wellness.ru">info@pro-wellness.ru</a>.</p>
            <p>12.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором. Политика действует бессрочно до замены ее новой версией.</p>
            <p>12.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу <a style={{ color: "inherit", textDecoration: "none" }} href="https://pro-wellness.ru/">https://pro-wellness.ru/</a>.</p>

            <address style={{ marginTop: 16, fontStyle: "normal", marginLeft: -16 }}>
              127081, Москва, Ясный проезд, 1<br />
              <a href="tel:+79251800099" style={{ color: "inherit", textDecoration: "none" }}>+7 925 180 0099</a>
            </address>
          </div>
        </section>

      </article>
    </main>
  );
};

export { default as routeMain } from "./routes";
export default PrivacyPage;

